module.exports = __webpack_public_path__ + "static/img/vipInfo.fe73baee.png";